interface Properties {
  inputType: string;
  newType: string;
  inputDataValues: Record<string, string>[];
  timeRange: string[];
  timeRangeYears: string[];
  timeDimension: number;
  inputDimensions: { id: string }[] | [];
}

const transformDataToUpdateDataInput = ({
  inputType,
  newType,
  inputDataValues,
  timeRange,
  timeRangeYears,
  timeDimension,
  inputDimensions,
}: Properties) => {
  let dataValues = [];
  if (inputType === 'constant' && newType === 'raw') {
    const createdDataValues = inputDataValues.reduce((accumulator: any, next) => {
      const innerData = timeRange.map((modelTime) => {
        return inputDimensions && inputDimensions.length > 0
          ? {
              [timeDimension]: modelTime,
              value: next.value,
              [inputDimensions[0].id]: next[inputDimensions[0].id],
            }
          : {
              [timeDimension]: modelTime,
              value: next.value,
            };
      });
      accumulator.push(innerData);
      return accumulator;
    }, []);
    dataValues = createdDataValues.flat(Number.POSITIVE_INFINITY);
  }

  if (inputType === 'constant_by_year' && newType === 'raw') {
    const timeRangeObject: any = {};
    timeRange.map((time: string) => {
      if (!timeRangeObject[`${time[4]}${time[5]}`]) {
        timeRangeObject[`${time[4]}${time[5]}`] = [];
      }
      timeRangeObject[`${time[4]}${time[5]}`].push(time);
      return timeRangeObject;
    });

    const createdDataValues = inputDataValues.reduce((accumulator: any, next) => {
      const year = next[timeDimension];
      const innerData = timeRangeObject[`${year[2]}${year[3]}`]?.map((modelTime: any) => {
        return inputDimensions && inputDimensions.length > 0
          ? {
              [timeDimension]: modelTime,
              value: next.value,
              [inputDimensions[0].id]: next[inputDimensions[0].id],
            }
          : {
              [timeDimension]: modelTime,
              value: next.value,
            };
      });
      accumulator.push(innerData);
      return accumulator;
    }, []);
    dataValues = createdDataValues.flat(Number.POSITIVE_INFINITY);
  }

  if (inputType === 'constant' && newType === 'constant_by_year') {
    const createdDataValues = inputDataValues.reduce((accumulator: any, next) => {
      const innerData = timeRangeYears.map((modelTime) => {
        return inputDimensions && inputDimensions.length > 0
          ? {
              [timeDimension]: modelTime,
              value: next.value,
              [inputDimensions[0].id]: next[inputDimensions[0].id],
            }
          : {
              [timeDimension]: modelTime,
              value: next.value,
            };
      });
      accumulator.push(innerData);
      return accumulator;
    }, []);
    dataValues = createdDataValues.flat(Number.POSITIVE_INFINITY);
  }

  if (inputType === 'constant' && newType === 'growth') {
    const createdDataValues = inputDataValues.reduce((accumulator: any, next) => {
      if (inputDimensions && inputDimensions.length > 0) {
        accumulator.push({
          [inputDimensions[0].id]: next[inputDimensions[0].id],
          start_value: next.value,
          growth_rate: '0',
        });
      } else {
        accumulator.push({
          start_value: next.value,
          growth_rate: '0',
        });
      }

      return accumulator;
    }, []);

    dataValues = createdDataValues;
  }

  if ((inputType === 'constant_by_year' || inputType === 'raw') && newType === 'constant') {
    let createdDataValues: Array<any> = [];
    if (inputDimensions && inputDimensions?.length) {
      const itemMap: any = {};
      inputDataValues.map((item: any) => {
        const itemData = JSON.parse(JSON.stringify(item));

        if (inputDimensions?.length && !itemMap[`${itemData[inputDimensions[0].id]}`]) {
          itemMap[`${itemData[inputDimensions[0].id]}`] = [];
        }

        delete itemData[`${timeDimension}`];
        if (inputDimensions?.length) itemMap[`${itemData[inputDimensions[0].id]}`].push(itemData);
        return itemData;
      });

      Object.keys(itemMap).map((key: any) => {
        let value = 0;
        itemMap[key].map((itemValue: any) => {
          value += +itemValue.value;
          return itemValue;
        });
        const row: any = JSON.parse(JSON.stringify(itemMap[key][0]));
        value /= itemMap[key].length;
        row.value = `${value}`;
        createdDataValues.push(row);
        return key;
      });
    } else {
      createdDataValues = [];
      let value = 0;
      inputDataValues.map((item: any) => {
        value += +item.value;
        return item;
      });
      value /= inputDataValues.length;
      const row: any = {};
      row.value = `${value}`;
      createdDataValues.push(row);
    }

    dataValues = createdDataValues.flat(Number.POSITIVE_INFINITY);
  }

  if (inputType === 'raw' && newType === 'constant_by_year') {
    let createdDataValues: Array<any> = [];
    if (inputDimensions && inputDimensions?.length > 0) {
      const groupedMap: any = {};
      inputDataValues.map((data: any) => {
        const month = data[timeDimension];
        if (!groupedMap[`${month[4]}${month[5]}`]) groupedMap[`${month[4]}${month[5]}`] = {};
        if (!groupedMap[`${month[4]}${month[5]}`][`${data[inputDimensions[0].id]}`])
          groupedMap[`${month[4]}${month[5]}`][`${data[inputDimensions[0].id]}`] = [];
        const dataArray = groupedMap[`${month[4]}${month[5]}`][`${data[inputDimensions[0].id]}`];
        dataArray.push(data);
        groupedMap[`${month[4]}${month[5]}`][`${data[inputDimensions[0].id]}`] = dataArray;
        return groupedMap;
      });

      timeRangeYears.map((year: string) => {
        if (groupedMap[`${year[2]}${year[3]}`]) {
          Object.keys(groupedMap[`${year[2]}${year[3]}`]).map((itemName: string) => {
            const row: any = JSON.parse(
              JSON.stringify(groupedMap[`${year[2]}${year[3]}`][`${itemName}`][0]),
            );
            let value = 0;
            groupedMap[`${year[2]}${year[3]}`][`${itemName}`].map((item: any) => {
              value += +item.value;
              return item;
            });
            value /= groupedMap[`${year[2]}${year[3]}`][`${itemName}`].length;
            row.value = `${value}`;
            row[timeDimension] = year;
            createdDataValues.push(row);
            return itemName;
          });
        }
        return createdDataValues;
      });
    } else {
      createdDataValues = [];
      const groupedMap: any = {};
      inputDataValues.map((item: any) => {
        if (!groupedMap[`${item[timeDimension][4]}${item[timeDimension][5]}`]) {
          groupedMap[`${item[timeDimension][4]}${item[timeDimension][5]}`] = [];
        }
        groupedMap[`${item[timeDimension][4]}${item[timeDimension][5]}`].push(item);
        return item;
      });

      timeRangeYears.map((year: string) => {
        if (groupedMap[`${year[2]}${year[3]}`]) {
          let value = 0;
          groupedMap[`${year[2]}${year[3]}`].map((itemData: any) => {
            value += +itemData.value;
            return itemData;
          });

          value /= groupedMap[`${year[2]}${year[3]}`].length;
          const row: any = {};
          row[`${timeDimension}`] = year;
          row.value = `${value}`;
          createdDataValues.push(row);
        }
        return year;
      });
    }

    dataValues = createdDataValues.flat(Number.POSITIVE_INFINITY);
  }

  if ((inputType === 'constant_by_year' || inputType === 'raw') && newType === 'growth') {
    let createdDataValues = [];
    if (inputDimensions && inputDimensions.length > 0) {
      createdDataValues = inputDataValues.reduce((accumulator: any, next) => {
        if (
          !accumulator.some(
            (item: any) =>
              inputDimensions &&
              inputDimensions.length > 0 &&
              item[inputDimensions[0].id] === next[inputDimensions[0].id],
          )
        ) {
          if (inputDimensions && inputDimensions.length > 0) {
            accumulator.push({
              [inputDimensions[0].id]: next[inputDimensions[0].id],
              start_value: next.value || next.start_value,
              growth_rate: '0',
            });
          } else {
            accumulator.push({
              start_value: next.value || next.start_value,
              growth_rate: '0',
            });
          }
        }
        return accumulator;
      }, []);
    } else {
      createdDataValues = [];
      let value = 0;
      inputDataValues.map((item: any) => {
        value += +item.value;
        return item;
      });
      value /= inputDataValues.length;
      const row: any = {};
      row.start_value = `${value}`;
      row.growth_rate = '0';
      createdDataValues.push(row);
    }
    dataValues = createdDataValues;
  }

  if (inputType === 'growth' && newType === 'constant') {
    const createdDataValues = inputDataValues.reduce((accumulator: any, next) => {
      if (inputDimensions && inputDimensions.length > 0) {
        accumulator.push({
          [inputDimensions[0].id]: next[inputDimensions[0].id],
          value: next.start_value,
        });
      } else {
        accumulator.push({
          value: next.start_value,
        });
      }

      return accumulator;
    }, []);

    dataValues = createdDataValues;
  }

  if (inputType === 'growth' && newType === 'raw') {
    const createdDataValues: Array<any> = [];

    inputDataValues.map((item) => {
      let sum = 0;
      let initialValue = Number.parseFloat(item.start_value);
      timeRange.map((month) => {
        const row: any = JSON.parse(JSON.stringify(item));
        row[`${timeDimension}`] = month;
        sum = sum * (Number.parseFloat(row.growth_rate) / 100) + initialValue;
        initialValue = sum;
        row.value = `${sum}`;
        delete row.growth_rate;
        delete row.start_value;
        createdDataValues.push(row);
        return month;
      });
      return item;
    });

    dataValues = createdDataValues.flat(Number.POSITIVE_INFINITY);
  }
  if (inputType === 'growth' && newType === 'constant_by_year') {
    const createdDataValues: Array<any> = [];

    inputDataValues.map((item) => {
      let sum = 0;
      let initialValue = Number.parseFloat(item.start_value);
      timeRangeYears.map((year) => {
        const row: any = JSON.parse(JSON.stringify(item));
        row[`${timeDimension}`] = year;
        sum = sum * (Number.parseFloat(row.growth_rate) / 100) + initialValue;
        initialValue = sum;
        row.value = `${sum}`;
        delete row.growth_rate;
        delete row.start_value;
        createdDataValues.push(row);
        return year;
      });
      return item;
    });

    dataValues = createdDataValues.flat(Number.POSITIVE_INFINITY);
  }

  return dataValues;
};

export default transformDataToUpdateDataInput;
